// @flow

import React from 'react'
import linkViewModel from '@vimcar/shared-utils/linkViewModel'
import cata from '@vimcar/shared-utils/cata'
import Loader from '@vimcar/shared-components/components/Loader'
import FullscreenMessage from '@vimcar/shared-components/components/FullscreenMessage'

import i18n from '#utils/i18n'
import mkViewModel, { type ViewModel } from './viewModel'

type Props = {
  viewModel: ViewModel,
}

const tp = i18n.prefix('components.dashboard')

const Logout = ({ viewModel }: Props) => cata({
  initializing: () => <Loader center/>,
  initialized: () => null,
  error: () => <FullscreenMessage title={tp('logout-failed')}/>,
})(viewModel.initializingState || 'error')

export default linkViewModel<any, any>(mkViewModel, Logout)
